/**
 * Format a date string to a human-readable format with ordinal suffix
 * @param dateString - ISO date string
 * @returns Formatted date string (e.g., "4th November, 2024")
 */
export const formatDate = (dateString: string): string => {
  if (!dateString) return '';
  const date = new Date(dateString);

  // Get day, month, and year
  const day = date.getDate();
  const month = date.toLocaleString('en-US', { month: 'long' });
  const year = date.getFullYear();

  // Add ordinal suffix to day
  const ordinalSuffix = getOrdinalSuffix(day);

  // Return formatted date: "4th November, 2024"
  return `${day}${ordinalSuffix} ${month}, ${year}`;
};

/**
 * Get the ordinal suffix for a number (1st, 2nd, 3rd, 4th, etc.)
 * @param day - The day number
 * @returns The ordinal suffix
 */
export const getOrdinalSuffix = (day: number): string => {
  if (day > 3 && day < 21) return 'th';
  switch (day % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};

/**
 * Format a date to ISO format (YYYY-MM-DD)
 * @param date - Date object or string
 * @returns ISO formatted date string
 */
export const formatISODate = (date: Date | string): string => {
  const d = typeof date === 'string' ? new Date(date) : date;
  return d.toISOString().split('T')[0];
};
